<template>
  <div class="login-main-page">
    <section class="login">
      <figure>
        <img src="@/assets/img/apps_logo-tall.png" alt="ENK apps" />
        <figcaption>{{ 'general:intro.welcome' | trans }}</figcaption>
      </figure>

      <a :href=login class="login">
        <img src="@/assets/img/ENKlogin.svg" :alt="$t('login')" />
      </a>
      <p>{{ 'general:intro.login_continue' | trans }}</p>
    </section>

    <section class="promo">
      <h1>Enkronos Apps</h1>
      <div>{{ 'general:intro.intro' | trans }}</div>
      <a href="https://www.aquest.io" target="_blank">
        <svgICO class="promo" />
      </a>
    </section>
  </div>
</template>

<script>
import Wizard from '@/helpers/components/display/Wizard'
import svg from '@/assets/img/aQuestICO.txt'
import _ from 'lodash'

const svgICO = {
  template: '<figure>' + svg + '</figure>'
};

export default {
  name: 'Login',
  components: {Wizard, svgICO},
  data () {return {
    previous: undefined,
  }},
  computed: {
    login () {
      var url =
        ENV.API_LOCATION.rtrim('/') + '/' +
        'v1/' +
        this.$i18n.i18next.language + '/' +
        'authentication/jwt/' +
        ENV.API_PUBLIC_TOKEN
      ;
      if (typeof this.previous === 'object' && this.previous.path && this.previous.path.length > 1) {
        url = url + '?redirect=' + this.previous.path;
      }
      return url;
    }
  },
  beforeRouteEnter (to, from, next) {
    next(self => {
      if (from && from.name && from.name !== 'login') {
        // access to component instance via `self`
        self.previous = from;
      }
    });
  },
  mounted () {
    document.body.classList.add('login');
    if (!this.previous && this.$route.query && this.$route.query.redirect) {
      this.previous = {
        path: this.$route.query.redirect
      };
    }
  },
  destroyed () {
    document.body.classList.remove('login');
  },
}
</script>

<style lang="scss">
  .login-main-page {

    $width: 1100px;
    $widthlimit: $width + 60px;
    $phoneposition: 0.57;
    
    margin-top: -$breadcrumbs-height;
    min-height: 100vh;
    background-color: #ECECEC;
    padding: 30px;
    @media (min-width: $widthlimit) {
      display: flex;
      padding: 117px 0 15px;
      padding-left: calc(42vw - #{$width * 0.42});
      padding-right: calc(58vw - #{$width * 0.58});

      $gradientstart: 39vh;
      
      background:
        linear-gradient(67deg, #F5F5F5 $gradientstart, rgba(black, .1) $gradientstart, transparent #{$gradientstart * 1.16}) center left / 100vh 100vh no-repeat,
        center left / cover no-repeat url('./login-bg.jpg')
      ;
      //(42vw - $width * 0.42) + $width = $phoneposition * X
      //(42vw + $width * (1 - 0.42) = $phoneposition * X
      //X = 42vw/$phoneposition + (1 - 0.42) * $width/$phoneposition

      background-size:
        100vh 100vh,
        calc(#{42vw / $phoneposition} + #{(1 - 0.42) * $width / $phoneposition})
      ;
      background-attachment: fixed;
    }
    @media (max-width: $widthlimit - 1px) {
      section {
        text-align: center;
      }
    }
    section.login {
      border-bottom: solid #707070 1px;
      padding-bottom: 30px;
      margin-bottom: 30px;
      @media (min-width: $widthlimit) {
        flex-basis: 46%;
        flex-shrink: 0;
        flex-grow: 0;
        padding: 42px 130px 42px 0;
        border-bottom: none;
        border-right: solid #707070 1px;
      }
      > figure {
        margin-bottom: 20px;
        @media (min-width: $widthlimit) {
          margin-bottom: 80px;
        }
        img {
          width: 169px;
          margin: -1px;
        }
        figcaption {
          margin: 16px 0 0;
          @include font-size(32px, 1.34);
          font-weight: 300;
          color: #7D7D7D;
          letter-spacing: 0.3em;
        }
      }
      a.login {
        img {
          width: 268px;
          margin: 0;
        }
      }
      p {
        margin: 7px 0;
        @include font-size(23px, 1.34);
        font-weight: 300;
        color: #7D7D7D;
        letter-spacing: 0.275em;
      }
    }
    section.promo {
      @media (min-width: $widthlimit) {
        padding: 42px 0 42px 99px;
      }
      h1 {
        @include font-size(22px);
        font-weight: 700;
        margin: 0 0 20px;
      }
      div {
        margin: 0 0 29px;
        @include font-size(20px, 31px);
        font-weight: 400;
      }
      img.promo {
        max-width: 495px;
        @media (max-width: $widthlimit - 1px) {
          margin: 0 #{-20px};
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/sections/general/Login.vue